/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener
 * crm-screener
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ScreenerDocumentErrorMetadataRelatedDocumentInformationInner
 */
export interface ScreenerDocumentErrorMetadataRelatedDocumentInformationInner {
    /**
     * 
     */
    name?: string;
    /**
     * 
     */
    size?: number;
    /**
     * 
     */
    pages?: number;
    /**
     * 
     */
    subtype?: string;
}

/**
 * Check if a given object implements the ScreenerDocumentErrorMetadataRelatedDocumentInformationInner interface.
 */
export function instanceOfScreenerDocumentErrorMetadataRelatedDocumentInformationInner(value: object): value is ScreenerDocumentErrorMetadataRelatedDocumentInformationInner {
    return true;
}

export function ScreenerDocumentErrorMetadataRelatedDocumentInformationInnerFromJSON(json: any): ScreenerDocumentErrorMetadataRelatedDocumentInformationInner {
    return ScreenerDocumentErrorMetadataRelatedDocumentInformationInnerFromJSONTyped(json, false);
}

export function ScreenerDocumentErrorMetadataRelatedDocumentInformationInnerFromJSONTyped(json: any, ignoreDiscriminator: boolean): ScreenerDocumentErrorMetadataRelatedDocumentInformationInner {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'] == null ? undefined : json['name'],
        'size': json['size'] == null ? undefined : json['size'],
        'pages': json['pages'] == null ? undefined : json['pages'],
        'subtype': json['subtype'] == null ? undefined : json['subtype'],
    };
}

export function ScreenerDocumentErrorMetadataRelatedDocumentInformationInnerToJSON(json: any): ScreenerDocumentErrorMetadataRelatedDocumentInformationInner {
    return ScreenerDocumentErrorMetadataRelatedDocumentInformationInnerToJSONTyped(json, false);
}

export function ScreenerDocumentErrorMetadataRelatedDocumentInformationInnerToJSONTyped(value?: ScreenerDocumentErrorMetadataRelatedDocumentInformationInner | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'size': value['size'],
        'pages': value['pages'],
        'subtype': value['subtype'],
    };
}

